import {
  Container,
  Typography,
  TextField,
  Button,
  Checkbox,
  Box,
  FormGroup,
  FormControlLabel,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Radio,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import HeaderComponent from "../components/HeaderComponent";
import { useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import Services from "../services/Services";
import CircularProgress from "@mui/material/CircularProgress";
import { useSelector } from "react-redux";
import Language from "../languages";

const label = { inputProps: { "aria-label": "Checkbox demo" } };

export default function MainPage() {
  const navigate = useNavigate();
  const projectName = useSelector((state) => state.projectName);
  const _mall = useSelector((state) => state.mall);
  const language = useSelector((state) => state.language);
  const uri = localStorage.getItem("mallUri");
  const storedMall = localStorage.getItem("mall");
  const isAkasyaMall = uri === "akasya-avm";
  // minFreeDeliveryPrice / isRequiredInvoiceForPrivateDelivery get-mall-token
  // yanıtında değil, AVM seçim ekranında SelectMallPage'in sakladığı
  // get-mall-list (mallList) yanıtında geliyor; seçili AVM'yi uri ile buluyoruz.
  const storedMallList = localStorage.getItem("mallList");
  const mallListItem = storedMallList
    ? JSON.parse(storedMallList).find((item) => item.uri === uri)
    : null;
  const [loginType, setLoginType] = useState("2");
  const [formData, setFormData] = useState({
    firm: "",
    name: "",
    lastname: "",
    phone: "",
    email: "",
    checkbox1: false,
    checkbox2: false,
    checkbox3: false,
    deliveryType: "",
  });
  const [additionalNote, setAdditionalNote] = useState("");
  const [mall, setMall] = useState();
  const [code, setCode] = useState("");
  const [userCode, setUserCode] = useState("");
  const [showCode, setShowCode] = useState(false);
  const [disabledPhone, setDisabledPhone] = useState(false);
  const [token, setToken] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [failed, setFailed] = useState(false);
  const [firstLogin, setFirstLogin] = useState(false);
  const [firstLoginComplete, setFirstLoginComplete] = useState(false);
  const [showRoomNo, setShowRoomNo] = useState(false);
  const [deliveryTypes, setDeliveryTypes] = useState([]);

  const [predefinedTypes, setPredefinedTypes] = useState([]);
  const [selectedAddressType, setSelectedAddressType] = useState("");
  const [selectedPredefined, setSelectedPredefined] = useState("");
  const [hotelRoom, setHotelRoom] = useState("");
  const [pointsTypes, setPointsTypes] = useState([]);
  const [selectedPointType, setSelectedPointType] = useState("");
  const [selectedSubValue, setSelectedSubValue] = useState("");
  const [townList, setTownList] = useState([]);
  const [selectedTown, setSelectedTown] = useState("");
  const [districtList, setDistrictList] = useState([]);
  const [selectedDistrict, setSelectedDistrict] = useState([]);
  const [freeDeliveryTownList, setFreeDeliveryTownList] = useState([]);
  const [lockBoxList, setLockBoxList] = useState([]);
  const [selectedLockBox, setSelectedLockBox] = useState("");
  const [fullAddress, setFullAddress] = useState("");
  const [addressDescription, setAddressDescription] = useState("");

  // Midtown + Salı için Easy Point kısıtlama dialog'u
  const [serviceDayDialogOpen, setServiceDayDialogOpen] = useState(false);

  // Seçili AVM'nin minimum ücretsiz hizmet tutarında alışverişlerde ücretsiz hizmet akışı
  const freeServiceEnabled = true;
  const minFreeServiceAmountFallback = 5000;
  const minFreeServiceAmount =
    Number(
      mallListItem?.minFreeDeliveryPrice ?? mall?.[0]?.minFreeDeliveryPrice
    ) || minFreeServiceAmountFallback;
  // AVM, özel teslimat için fiş ibrazı istiyorsa fiş yükleme adımı akışa dahil olur
  const requireInvoiceForPrivateDelivery =
    (mallListItem?.isRequiredInvoiceForPrivateDelivery ??
      mall?.[0]?.isRequiredInvoiceForPrivateDelivery) === "1";

  const [isFreeServiceEligible, setIsFreeServiceEligible] = useState(false);
  const [flowStep, setFlowStep] = useState("form"); // "form" | "receiptUpload" | "deliveryTime"
  const [receiptFiles, setReceiptFiles] = useState([]);
  const [selectedDeliveryTimeSlot, setSelectedDeliveryTimeSlot] = useState("");
  const [freeServiceSuccessOpen, setFreeServiceSuccessOpen] = useState(false);
  const [freeServiceSubmitting, setFreeServiceSubmitting] = useState(false);
  const receiptFileInputRef = useRef(null);

  // 18.00-20.00 ve 20.00-22.00 yoğunluk sebebiyle her zaman dolu kabul edilir.
  // Diğer aralıklar, o aralığın başlangıç saatine henüz girilmediyse (o anki saat
  // itibarıyla) uygun kabul edilir; başlangıç saatine girildiği an seçilemez olur.
  const alwaysFullSlotIds = ["18-20", "20-22"];
  const deliveryTimeSlotDefs = [
    { id: "12-14", label: "12.00 - 14.00", startHour: 12 },
    { id: "14-16", label: "14.00 - 16.00", startHour: 14 },
    { id: "16-18", label: "16.00 - 18.00", startHour: 16 },
    { id: "18-20", label: "18.00 - 20.00", startHour: 18 },
    { id: "20-22", label: "20.00 - 22.00", startHour: 20 },
  ];

  const getDeliveryTimeSlots = () => {
    const now = new Date();
    const currentMinutes = now.getHours() * 60 + now.getMinutes();

    return deliveryTimeSlotDefs.map((slot) => {
      if (alwaysFullSlotIds.includes(slot.id)) {
        return { ...slot, status: "full" };
      }
      return {
        ...slot,
        status: currentMinutes >= slot.startHour * 60 ? "past" : "available",
      };
    });
  };

  const deliveryTimeSlots = getDeliveryTimeSlots();

  const handleSuccess = () => {
    setSuccess(true);
    setLoading(false);
  };

  const handleFailed = () => {
    setFailed(true);
    setLoading(false);
  };

  const handleInputChange = (event) => {
    const { name, value, checked, type } = event.target;

    // Teslimat tipi değişiyorsa ve Easy Point seçilmeye çalışılıyorsa burada yakalıyoruz
    if (name === "deliveryType") {
      const isMidtown = mall && mall[0]?.uri === "midtown-avm";
      const today = new Date();
      const isTuesday = today.getDay() === 2; // 0: Pazar, 1: Pazartesi, 2: Salı

      // deliveryTypes içinden seçilen type'ı bul
      const selectedTypeObj = deliveryTypes.find((t) => t.type === value);
      const isEasyPointTitle = selectedTypeObj?.title === "Easy Point";

      // Midtown + Salı + Easy Point ise seçime izin verme, uyarı göster
      if (isMidtown && isTuesday && isEasyPointTitle) {
        setServiceDayDialogOpen(true);

        // Var olan seçimleri temizle, deliveryType'ı da boş bırak
        setFormData((prevData) => ({
          ...prevData,
          deliveryType: "",
        }));
        setSelectedAddressType("");
        setSelectedPredefined("");
        setSelectedPointType("");
        setSelectedSubValue("");
        resetTownAndDistrict();
        setSelectedLockBox("");
        setFullAddress("");
        setAddressDescription("");
        return; // Aşağıdaki genel setFormData çalışmasın
      }

      // Normal durumda (yasak değilse) teslimat tipi değişince dependent alanları temizliyoruz
      setSelectedAddressType("");
      setSelectedPredefined("");
      setSelectedPointType("");
      setSelectedSubValue("");
      resetTownAndDistrict();
      setSelectedLockBox("");
      setFullAddress("");
      setAddressDescription("");
    }

    // Genel form state güncellemesi
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handlePointTypeChange = (event) => {
    setSelectedPointType(event.target.value);
    setSelectedSubValue("");
  };

  const handlePredefinedTypeChange = (event) => {
    setSelectedAddressType(event.target.value);
    setSelectedPredefined("");
    resetTownAndDistrict();
    setHotelRoom("");
    setFullAddress("");
    setAddressDescription("");
  };

  const handleCreate = (
    token,
    name,
    lastname,
    phone,
    email,
    firm,
    additionalNote,
    extraData = {},
    { onSuccess = handleSuccess, onFailure = handleFailed, dryRun = false } = {}
  ) => {
    let deliveryTypeInfo = {};

    if (selectedSubValue) {
      deliveryTypeInfo = {
        deliveryType: formData.deliveryType,
        type: selectedSubValue.type,
        id: selectedSubValue.id,
        text: selectedSubValue.title,
        additionalNote: addressDescription,
        price: selectedSubValue.price,
        currency: selectedSubValue.currency,
      };
      if (selectedSubValue.autoReturnSetInBranchToComplete === true) {
        deliveryTypeInfo.autoReturnSetInBranchToComplete = true;
      }
      if (selectedSubValue.inMall === true) {
        deliveryTypeInfo.inMall = true;
      }
    } else if (selectedPredefined) {
      deliveryTypeInfo = {
        deliveryType: formData.deliveryType,
        type: "predefined",
        predefinedType: selectedPredefined.type,
        text: selectedPredefined.title,
        additionalNote: "(Oda No: " + hotelRoom + ") " + addressDescription,
        price: selectedPredefined.price,
        currency: selectedPredefined.currency,
      };
    } else if (selectedTown) {
      deliveryTypeInfo = {
        deliveryType: formData.deliveryType,
        type: "custom",
        text: selectedTown + " " + selectedDistrict + " " + fullAddress,
        additionalNote: addressDescription,
        price:
          JSON.parse(storedMall)[0].deliveryTypes.localDelivery[selectedTown]
            .price,
        currency:
          JSON.parse(storedMall)[0].deliveryTypes.localDelivery[selectedTown]
            .currency,
      };
    } else if (selectedLockBox) {
      deliveryTypeInfo = {
        deliveryType: formData.deliveryType,
        locationCode: selectedLockBox.locationCode,
        text: selectedLockBox.title,
        additionalNote: addressDescription,
        price: selectedLockBox.price,
        currency: selectedLockBox.currency,
        id: selectedLockBox.id,
      };
    }

    // Seçili AVM'nin id'sini (mall state'i localStorage'daki "mall" verisinden
    // türetiliyor) her order-create isteğinde mallID olarak gönderiyoruz.
    const mallID = mall?.[0]?.id;
    const orderExtraData = { mallID, ...extraData };

    console.log("[MainPage] CreateOrder payload:", {
      token,
      name,
      lastname,
      phone,
      email,
      locationID: firm,
      additionalNote: `${name} ${lastname} ${additionalNote}`,
      deliveryTypeInfo,
      ...orderExtraData,
    });

    if (dryRun) {
      onSuccess();
      return;
    }

    Services.CreateOrder(
      token,
      name,
      lastname,
      phone,
      email,
      firm,
      `${name} ${lastname} ${additionalNote}`,
      deliveryTypeInfo,
      orderExtraData
    )
      .then((res) => {
        if (res.data.status) {
          if (firstLogin) {
            localStorage.setItem("name", name);
            localStorage.setItem("lastname", lastname);
            localStorage.setItem("phone", phone);
            localStorage.setItem("email", email);
          }
          onSuccess();
        } else {
          onFailure();
        }
      })
      .catch((err) => {
        // console.log(err);
        onFailure();
      });
  };

  const userControl = () => {
    let getCustomerBy = formData.email ? "email" : "phone";
    let getCustomerByValue = formData.email ? formData.email : formData.phone;

    Services.GetCustomer(token, getCustomerBy, getCustomerByValue)
      .then((res) => {
        // console.log("Get Customer Response: ", res.data);
        if (res.data.status) {
          const result = res.data.result || {};
          localStorage.setItem("name", result.name || "");
          localStorage.setItem("lastname", result.lastname || "");
          localStorage.setItem("phone", result.phone || "");
          localStorage.setItem("customerID", result.customerID || "");
          localStorage.setItem("email", result.email || "");

          setLoginType("3");
          setShowCode(false);
          setDisabledPhone(true);
          setFirstLoginComplete(true);

          // Eski formData'yı bozmadan sadece ilgili alanları güncelle
          setFormData((prev) => ({
            ...prev,
            name: result.name || "",
            lastname: result.lastname || "",
            phone: result.phone || "",
            email: result.email || "",
          }));
        } else {
          setLoginType("3");
          setShowCode(false);
          setDisabledPhone(true);
          setFirstLoginComplete(true);
        }
      })
      .catch((err) => {
        // console.log(err);
        setLoginType("3");
        setShowCode(false);
        setDisabledPhone(true);
        setFirstLoginComplete(true);
      });
  };

  const sendSMS = (phone) => {
    const _code = Math.floor(100000 + Math.random() * 900000).toString();
    setCode(_code);
    const message = `Telefon numaranızı doğrulamanız için ${_code} kodunu gerekli alana giriniz.`;
    Services.SendSMS(token, phone, message)
      .then((res) => {
        // console.log(res.data);
      })
      .catch((err) => {
        // console.log(err);
      });
  };

  const handleContinue = () => {
    const { name, firm, lastname, phone, email } = formData;

    if (firstLogin && firstLoginComplete === false) {
      if (loginType === "2") {
        setShowCode(true);
        if (showCode) {
          if (userCode === code) {
            userControl();
          } else {
            window.alert(
              language === "tr"
                ? "Kodlar uyuşmuyor, tekrar deneyiniz."
                : "Codes don't match, please try again."
            );
          }
        } else {
          sendSMS(phone);
        }
      }
    } else {
      const shouldStartFreeServiceFlow =
        freeServiceEnabled &&
        isFreeServiceEligible &&
        formData.deliveryType === "address" &&
        selectedAddressType === "address";

      if (shouldStartFreeServiceFlow) {
        setFlowStep(
          requireInvoiceForPrivateDelivery ? "receiptUpload" : "deliveryTime"
        );
      } else {
        setLoading(true);
        handleCreate(
          token,
          name,
          lastname,
          phone,
          email,
          resolveLocationID(firm),
          additionalNote,
          buildResponsibleExtraData(firm)
        );
      }
    }
  };

  // Akasya'da mağaza listesine elle eklediğimiz "Easypoint" seçildiğinde
  // servise isResponsibleByEasypoint:true ve locationType:"easypoint-desk" gönderilir.
  const buildResponsibleExtraData = (firmValue) =>
    firmValue === "easypoint"
      ? { isResponsibleByEasypoint: true, locationType: "easypoint-desk" }
      : {};

  // "easypoint" placeholder değeri servise locationID olarak gidemez;
  // AVM'nin deliveryTypes.points içindeki gerçek easypoint noktasının id'sine çeviriyoruz.
  const resolveLocationID = (firmValue) => {
    if (firmValue !== "easypoint") return firmValue;
    const easypointId = mall?.[0]?.deliveryTypes?.points?.find(
      (point) => point.type === "easypoint"
    )?.id;
    return easypointId || firmValue;
  };

  const handleReceiptFilesChange = (event) => {
    const selected = Array.from(event.target.files || []);
    const notImage = selected.some((file) => !file.type.startsWith("image/"));
    const oversized = selected.some((file) => file.size > 5 * 1024 * 1024);

    if (notImage) {
      window.alert(
        language === "tr"
          ? "Sadece görsel dosyaları yükleyebilirsiniz."
          : "You can only upload image files."
      );
    }
    if (oversized) {
      window.alert(
        language === "tr"
          ? "Dosya boyutu 5MB'ı geçemez."
          : "File size cannot exceed 5MB."
      );
    }

    const accepted = selected
      .filter(
        (file) =>
          file.type.startsWith("image/") && file.size <= 5 * 1024 * 1024
      )
      .map((file) => ({
        id: `${file.name}-${file.size}-${Date.now()}-${Math.random()}`,
        file,
        name: file.name,
        size: file.size,
        previewUrl: URL.createObjectURL(file),
      }));

    setReceiptFiles((prev) => [...prev, ...accepted]);
    event.target.value = "";
  };

  // data:image/jpeg;base64,xxxx -> base64 gövdesini ve uzantısını ayırır
  const fileToBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });

  const getFileExtension = (file) => {
    const nameParts = file.name ? file.name.split(".") : [];
    if (nameParts.length > 1) {
      return nameParts[nameParts.length - 1].toLowerCase();
    }
    return (file.type?.split("/")[1] || "jpg").toLowerCase();
  };

  const buildInvoiceImages = (files) =>
    Promise.all(
      files.map(async (item) => {
        const dataUrl = await fileToBase64(item.file);
        const base64 = dataUrl.split(",")[1] || dataUrl;
        return {
          file: base64,
          extension: getFileExtension(item.file),
        };
      })
    );

  // "14-16" -> "14:00-16:00"
  const slotIdToTimeRange = (slotId) => {
    const [start, end] = slotId.split("-");
    return `${start.padStart(2, "0")}:00-${end.padStart(2, "0")}:00`;
  };

  const handleFreeServiceOrderSubmit = async () => {
    if (!selectedDeliveryTimeSlot || freeServiceSubmitting) return;

    const { name, firm, lastname, phone, email } = formData;
    setFreeServiceSubmitting(true);

    try {
      const invoiceImages = requireInvoiceForPrivateDelivery
        ? await buildInvoiceImages(receiptFiles)
        : undefined;
      const privateDeliveryRequestedTimeRange = slotIdToTimeRange(
        selectedDeliveryTimeSlot
      );

      handleCreate(
        token,
        name,
        lastname,
        phone,
        email,
        resolveLocationID(firm),
        additionalNote,
        {
          ...(invoiceImages ? { invoiceImages } : {}),
          privateDeliveryRequestedTimeRange,
          isPrivateDeliveryRequest: true,
          ...buildResponsibleExtraData(firm),
        },
        {
          onSuccess: () => {
            setFreeServiceSubmitting(false);
            setFreeServiceSuccessOpen(true);
          },
          onFailure: () => {
            setFreeServiceSubmitting(false);
            window.alert(
              language === "tr"
                ? "İşlem gerçekleştirilemedi, lütfen tekrar deneyiniz."
                : "Something went wrong, please try again."
            );
          },
        }
      );
    } catch (err) {
      setFreeServiceSubmitting(false);
      window.alert(
        language === "tr"
          ? "Görseller işlenirken bir hata oluştu."
          : "An error occurred while processing the images."
      );
    }
  };

  const removeReceiptFile = (id) => {
    setReceiptFiles((prev) => prev.filter((item) => item.id !== id));
  };

  const formatFileSize = (bytes) => {
    const mb = bytes / (1024 * 1024);
    return mb >= 1
      ? `${mb.toFixed(1)} MB`
      : `${Math.max(1, Math.round(bytes / 1024))} KB`;
  };

  const resetFreeServiceFlow = () => {
    setFlowStep("form");
    setIsFreeServiceEligible(false);
    setReceiptFiles([]);
    setSelectedDeliveryTimeSlot("");
  };

  function extractUniqueTypes(dataArray) {
    const types = new Set();

    dataArray?.forEach((item) => {
      if (item.type) {
        types.add(item.type);
      }
    });

    return Array.from(types);
  }

  const extractTowns = (obj) => {
    if (obj) {
      return Object.keys(obj).map((town) => town);
    }
  };

  const extractFreeDeliveryTowns = (localDelivery) => {
    if (!localDelivery) return [];
    return Object.keys(localDelivery).filter(
      (town) => localDelivery[town]?.freeDeliveryNeigbours?.length > 0
    );
  };

  // Tek ilçe/mahalle varsa boşa değil, otomatik seçili haline resetler.
  // freeOnly=true iken sadece freeDeliveryNeigbours'u olan ilçeler/mahalleler dikkate alınır
  // (5.000 TL ve üzeri alışveriş checkbox'ı işaretliyken).
  const resetTownAndDistrict = (freeOnly = isFreeServiceEligible) => {
    const localDelivery = storedMall
      ? JSON.parse(storedMall)[0]?.deliveryTypes?.localDelivery
      : null;
    const allTowns = localDelivery ? Object.keys(localDelivery) : [];
    const towns = freeOnly ? extractFreeDeliveryTowns(localDelivery) : allTowns;

    if (towns.length === 1) {
      const singleTown = towns[0];
      const neigboursArr = freeOnly
        ? localDelivery[singleTown]?.freeDeliveryNeigbours || []
        : localDelivery[singleTown]?.neigbours || [];
      setSelectedTown(singleTown);
      setDistrictList(neigboursArr);
      setSelectedDistrict(neigboursArr.length === 1 ? neigboursArr[0] : "");
    } else {
      setSelectedTown("");
      setDistrictList([]);
      setSelectedDistrict("");
    }
  };

  const handleFreeServiceEligibleChange = (event) => {
    const checked = event.target.checked;
    setIsFreeServiceEligible(checked);
    resetTownAndDistrict(checked);
  };

  function checkDataAvailability(data) {
    const result = {};

    // isVisible alanı açıkça false olmadıkça nokta görünür kabul edilir
    // (Akasya'daki gibi bazı point objeleri sadece id çözümlemek için
    // tutuluyor ve seçenek olarak gösterilmemeli).
    const visiblePoints = data?.points?.filter(
      (point) => point.isVisible !== false
    );

    let deliveryTypesArr = [];
    let predefinedTypesArr = extractUniqueTypes(data?.predefined);
    let pointsTypesArr = extractUniqueTypes(visiblePoints);
    let townListArr = extractTowns(data?.localDelivery);
    let lockBoxListArr = data.postbox;

    const isValid = (value) =>
      value !== null &&
      value !== false &&
      value !== undefined &&
      (Array.isArray(value)
        ? value?.length > 0
        : Object.keys(value || {})?.length > 0);

    // Points kontrolü
    if (isValid(visiblePoints)) {
      result.points = "Points mevcut ve geçerli.";
      deliveryTypesArr.push({ type: "points", title: "Easy Point" });
    }

    // Predefined kontrolü
    if (isValid(data.predefined) || isValid(data.localDelivery)) {
      result.predefined = "Predefined mevcut ve geçerli.";
      deliveryTypesArr.push({
        type: "address",
        title: Language(_mall, language, "deliverToAddress"),
      });
    }

    // Postbox kontrolü
    if (isValid(data.postbox)) {
      result.postbox = "Postbox mevcut ve geçerli.";
      deliveryTypesArr.push({
        type: "postbox",
        title: Language(_mall, language, "deliverToLockBox"),
      });
    }

    // LocalDelivery kontrolü
    if (isValid(data.localDelivery)) {
      result.localDelivery = "LocalDelivery mevcut ve geçerli.";
    }

    if (townListArr?.length === 1) {
      const singleTown = townListArr[0];
      setSelectedTown(singleTown);
      const neigboursArr = data?.localDelivery?.[singleTown]?.neigbours || [];
      setDistrictList(neigboursArr);
      if (neigboursArr.length === 1) {
        setSelectedDistrict(neigboursArr[0]);
      }
    }

    setFreeDeliveryTownList(extractFreeDeliveryTowns(data?.localDelivery));
    setLockBoxList(lockBoxListArr);
    setTownList(townListArr);
    setPointsTypes(pointsTypesArr);
    setPredefinedTypes(predefinedTypesArr);
    setDeliveryTypes(deliveryTypesArr);
  }

  const handleChangeTown = (event) => {
    const parsedMall = JSON.parse(storedMall);
    const data = parsedMall[0].deliveryTypes;
    const town = event.target.value;
    const neigboursArr = isFreeServiceEligible
      ? data.localDelivery[town]?.freeDeliveryNeigbours || []
      : data.localDelivery[town]?.neigbours || [];
    setSelectedTown(town);
    setDistrictList(neigboursArr);
    setSelectedDistrict(neigboursArr.length === 1 ? neigboursArr[0] : "");
  };

  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    const storedName = localStorage.getItem("name");
    const storedLastname = localStorage.getItem("lastname");
    const storedPhone = localStorage.getItem("phone");
    const storedEmail = localStorage.getItem("email");
    setToken(storedToken || "");

    if (storedMall) {
      const parsedMall = JSON.parse(storedMall);
      checkDataAvailability(parsedMall[0]?.deliveryTypes);
      if (parsedMall[0]?.uri === "istinyepark-izmir") {
        setShowRoomNo(true);
      }
      setMall(parsedMall);
    }

    if (storedName) {
      setFormData((prevData) => ({
        ...prevData,
        name: storedName || "",
        lastname: storedLastname || "",
        phone: storedPhone || "",
        email: storedEmail || "",
      }));
      setDisabledPhone(true);
      setFirstLogin(false);
      setLoginType("1");
    } else {
      setFormData((prevData) => ({
        ...prevData,
        name: "",
        lastname: "",
        phone: "",
        email: "",
      }));
      setDisabledPhone(false);
      setFirstLogin(true);
      setLoginType("2");
    }
  }, [storedMall, language]);

  const isButtonDisabled = () => {
    if (!formData.deliveryType) return true;

    if (formData.deliveryType === "points") {
      return !selectedPointType || !selectedSubValue;
    }

    if (formData.deliveryType === "address") {
      if (!selectedAddressType) return true;

      if (selectedAddressType === "address") {
        return !selectedTown || !selectedDistrict || !fullAddress;
      }
      if (selectedAddressType === "predefined") {
        return (
          !selectedPredefined ||
          (selectedPredefined.type === "hotel" && !hotelRoom)
        );
      }
    }

    if (formData.deliveryType === "postbox") {
      return !selectedLockBox;
    }

    return false;
  };

  const mallUri = mall?.[0]?.uri;

  const use17Cutoff =
    mallUri === "zorlu-center" ||
    mallUri === "kanyon-avm" ||
    mallUri === "cevahir-avm" ||
    mallUri === "emaar-square";

  if (flowStep === "receiptUpload") {
    return (
      <Container>
        <Box sx={{ my: 4, mx: 2 }}>
          <HeaderComponent
            middle="logo"
            goBack={() => setFlowStep("form")}
            left="back"
            right="icon"
          />

          <Box sx={{ marginTop: 10 }}>
            <Typography
              variant="h5"
              component="h4"
              textAlign="center"
              sx={{
                lineHeight: "26.63px",
                fontSize: 20,
                fontWeight: 700,
                marginBottom: 4,
              }}
            >
              {Language(_mall, language, "uploadReceiptTitle")}
            </Typography>

            <Box
              sx={{
                display: "grid",
                gridTemplateColumns:
                  "repeat(auto-fill, minmax(96px, 1fr))",
                gap: 2,
                marginBottom: 2,
              }}
            >
              <Box
                onClick={() => receiptFileInputRef.current?.click()}
                sx={{
                  border: "1px dashed #C1C6C9",
                  borderRadius: 2,
                  aspectRatio: "1 / 1",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  backgroundColor: "#ffffff",
                  padding: 1,
                  textAlign: "center",
                }}
              >
                <AddIcon sx={{ color: "#FF6E60", fontSize: 26 }} />
                <Typography
                  sx={{ fontSize: 11, fontWeight: 600, marginTop: 0.5 }}
                >
                  {Language(_mall, language, "addReceiptImage")}
                </Typography>
                <Typography sx={{ fontSize: 9, color: "#8B8B8B" }}>
                  {Language(_mall, language, "receiptFileFormats")}
                </Typography>
                <Typography sx={{ fontSize: 9, color: "#8B8B8B" }}>
                  {Language(_mall, language, "receiptMaxSize")}
                </Typography>
              </Box>

              {receiptFiles.map((item) => (
                <Box
                  key={item.id}
                  sx={{
                    position: "relative",
                    border: "1px solid #E5E5E5",
                    borderRadius: 2,
                    aspectRatio: "1 / 1",
                    overflow: "hidden",
                    backgroundColor: "#ffffff",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <IconButton
                    size="small"
                    onClick={() => removeReceiptFile(item.id)}
                    sx={{
                      position: "absolute",
                      top: 2,
                      right: 2,
                      backgroundColor: "rgba(255,255,255,0.9)",
                      padding: "2px",
                      zIndex: 1,
                      "&:hover": { backgroundColor: "#ffffff" },
                    }}
                  >
                    <CloseIcon sx={{ fontSize: 14 }} />
                  </IconButton>
                  {item.previewUrl ? (
                    <Box
                      component="img"
                      src={item.previewUrl}
                      alt={item.name}
                      sx={{
                        width: "100%",
                        height: "70%",
                        objectFit: "cover",
                      }}
                    />
                  ) : (
                    <Box
                      sx={{
                        width: "100%",
                        height: "70%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <InsertDriveFileOutlinedIcon
                        sx={{ color: "#C1C6C9", fontSize: 30 }}
                      />
                    </Box>
                  )}
                  <Box sx={{ padding: "2px 4px", overflow: "hidden" }}>
                    <Typography
                      noWrap
                      sx={{ fontSize: 9, fontWeight: 600 }}
                    >
                      {item.name}
                    </Typography>
                    <Typography sx={{ fontSize: 8, color: "#8B8B8B" }}>
                      {formatFileSize(item.size)}
                    </Typography>
                  </Box>
                </Box>
              ))}
            </Box>

            <input
              ref={receiptFileInputRef}
              type="file"
              accept="image/*"
              multiple
              hidden
              onChange={handleReceiptFilesChange}
            />

            <Typography
              textAlign="center"
              sx={{ color: "#5E596D", fontSize: 12, marginBottom: 6 }}
            >
              {Language(
                _mall,
                language,
                "receiptCheckNotice",
                projectName
              )}
            </Typography>

            <Button
              variant="contained"
              color="newRed"
              fullWidth
              sx={{ paddingY: 1.2 }}
              disabled={receiptFiles.length === 0}
              onClick={() => setFlowStep("deliveryTime")}
            >
              {Language(_mall, language, "continue")}
            </Button>
          </Box>
        </Box>

        <Typography
          sx={{
            color: "black",
            fontSize: 8,
            bottom: 5,
            textAlign: "center",
          }}
        >
          {Language(_mall, language, "version")} 0.2.5
        </Typography>
      </Container>
    );
  }

  if (flowStep === "deliveryTime") {
    return (
      <Container>
        <Box sx={{ my: 4, mx: 2 }}>
          <HeaderComponent
            middle="logo"
            goBack={() =>
              setFlowStep(
                requireInvoiceForPrivateDelivery ? "receiptUpload" : "form"
              )
            }
            left="back"
            right="icon"
          />

          <Box sx={{ marginTop: 10 }}>
            <Typography
              variant="h5"
              component="h4"
              textAlign="center"
              sx={{
                lineHeight: "26.63px",
                fontSize: 18,
                fontWeight: 700,
                marginBottom: 3,
              }}
            >
              {Language(_mall, language, "selectDeliveryTimeTitle")}
            </Typography>

            <Box
              sx={{
                border: "1px solid #E5E5E5",
                borderRadius: 2,
                overflow: "hidden",
                marginBottom: 2,
              }}
            >
              {deliveryTimeSlots.map((slot, index) => {
                const disabled = slot.status !== "available";
                const statusLabel =
                  slot.status === "past"
                    ? Language(_mall, language, "timeSlotPast")
                    : slot.status === "full"
                    ? Language(_mall, language, "timeSlotFull")
                    : Language(_mall, language, "timeSlotAvailable");

                return (
                  <Box
                    key={slot.id}
                    onClick={() =>
                      !disabled && setSelectedDeliveryTimeSlot(slot.id)
                    }
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      flexWrap: "wrap",
                      gap: 1,
                      padding: "10px 16px",
                      borderBottom:
                        index !== deliveryTimeSlots.length - 1
                          ? "1px solid #E5E5E5"
                          : "none",
                      cursor: disabled ? "not-allowed" : "pointer",
                      opacity: disabled ? 0.6 : 1,
                      backgroundColor:
                        selectedDeliveryTimeSlot === slot.id
                          ? "#FFF1EF"
                          : "#ffffff",
                    }}
                  >
                    <Box
                      sx={{ display: "flex", alignItems: "center", gap: 1 }}
                    >
                      <Radio
                        checked={selectedDeliveryTimeSlot === slot.id}
                        disabled={disabled}
                        color="newRed"
                        size="small"
                        icon={
                          disabled ? (
                            <LockOutlinedIcon
                              sx={{ fontSize: 18, color: "#C1C6C9" }}
                            />
                          ) : undefined
                        }
                      />
                      <Typography sx={{ fontSize: 14, fontWeight: 600 }}>
                        {slot.label}
                      </Typography>
                    </Box>
                    <Typography
                      sx={{
                        fontSize: 11,
                        fontWeight: 700,
                        padding: "2px 10px",
                        borderRadius: 10,
                        color:
                          slot.status === "available"
                            ? "#1E8E3E"
                            : slot.status === "full"
                            ? "#DF524C"
                            : "#8B8B8B",
                        backgroundColor:
                          slot.status === "available"
                            ? "#E6F4EA"
                            : slot.status === "full"
                            ? "#FDECEA"
                            : "#F0F0F0",
                      }}
                    >
                      {statusLabel}
                    </Typography>
                  </Box>
                );
              })}
            </Box>

            <Box
              sx={{
                display: "flex",
                gap: 1,
                backgroundColor: "#F5F5F5",
                borderRadius: 2,
                padding: 1.5,
                marginBottom: 6,
              }}
            >
              <InfoOutlinedIcon sx={{ color: "#8B8B8B", fontSize: 18 }} />
              <Typography sx={{ fontSize: 12, color: "#5E596D" }}>
                {Language(_mall, language, "timeSlotFullNotice")}
              </Typography>
            </Box>

            <Button
              variant="contained"
              color="newRed"
              fullWidth
              sx={{ paddingY: 1.2 }}
              disabled={!selectedDeliveryTimeSlot || freeServiceSubmitting}
              onClick={handleFreeServiceOrderSubmit}
            >
              {freeServiceSubmitting ? (
                <CircularProgress size={20} sx={{ color: "#fff" }} />
              ) : (
                Language(_mall, language, "continue")
              )}
            </Button>
          </Box>
        </Box>

        <Dialog
          open={freeServiceSuccessOpen}
          PaperProps={{
            sx: {
              borderRadius: 3,
              padding: 2,
              textAlign: "center",
              maxWidth: 320,
              width: "90%",
            },
          }}
          sx={{
            "& .MuiBackdrop-root": {
              backgroundColor: "rgba(0,0,0,0.6)",
            },
          }}
        >
          <DialogContent>
            <Box
              sx={{ display: "flex", justifyContent: "center", marginBottom: 2 }}
            >
              <Box
                sx={{
                  width: 64,
                  height: 64,
                  borderRadius: "50%",
                  backgroundColor: "#2FA84F",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <CheckIcon sx={{ color: "#ffffff", fontSize: 36 }} />
              </Box>
            </Box>
            <Typography sx={{ fontWeight: 700, fontSize: 16 }}>
              {Language(_mall, language, "transactionSuccess")}
            </Typography>
          </DialogContent>
          <DialogActions sx={{ justifyContent: "center", paddingBottom: 2 }}>
            <Button
              variant="contained"
              color="newRed"
              fullWidth
              sx={{ paddingY: 1.2, marginX: 2 }}
              onClick={() => {
                setFreeServiceSuccessOpen(false);
                resetFreeServiceFlow();
                navigate(`/${uri}`);
              }}
            >
              {Language(_mall, language, "complete")}
            </Button>
          </DialogActions>
        </Dialog>

        <Typography
          sx={{
            color: "black",
            fontSize: 8,
            bottom: 5,
            textAlign: "center",
          }}
        >
          {Language(_mall, language, "version")} 0.2.5
        </Typography>
      </Container>
    );
  }

  return (
    <Container>
      <Box sx={{ my: 4, mx: 2 }}>
        <HeaderComponent
          middle="logo"
          goBack={() => navigate(`/${uri}`)}
          left="back"
          right="icon"
        />

        <Box sx={{ marginTop: 10 }}>
          <Typography
            variant="h5"
            component="h4"
            textAlign="center"
            sx={{
              lineHeight: "26.63px",
              fontSize: 22,
              fontWeight: 700,
              marginBottom: 2,
            }}
          >
            {projectName}
          </Typography>
          <Typography
            variant="subtitle2"
            component="h4"
            textAlign="center"
            marginX={8}
            sx={{
              color: "#5E596D",
              lineHeight: "16.94px",
              fontSize: 14,
              fontWeight: 400,
              marginBottom: 5,
            }}
          >
            {loginType === "1" || loginType === "3"
              ? Language(_mall, language, "selectStoreTitle")
              : Language(_mall, language, "selectPhone")}
          </Typography>

          {(loginType === "1" || loginType === "3") && (
            <>
              <FormControl fullWidth>
                <InputLabel
                  style={{ color: "#C1C6C9", fontSize: 15 }}
                  id="demo-simple-select-label"
                >
                  {Language(_mall, language, "firm")}*
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label={Language(_mall, language, "firm")}
                  name="firm"
                  value={formData.firm}
                  onChange={handleInputChange}
                  sx={{
                    marginBottom: 2,
                    backgroundColor: "#ffffff",
                    borderColor: "#C1C6C9",
                  }}
                >
                  {mall &&
                    mall[0].stores.map((store) => (
                      <MenuItem key={store.id} value={store.id}>
                        {store.title}
                      </MenuItem>
                    ))}
                  {mall && isAkasyaMall && (
                    <MenuItem key="easypoint" value="easypoint">
                      Easypoint
                    </MenuItem>
                  )}
                </Select>
              </FormControl>
              <TextField
                id="outlined-basic-1"
                label={`${Language(_mall, language, "name")}*`}
                variant="outlined"
                fullWidth
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                InputLabelProps={{
                  style: { color: "#C1C6C9", fontSize: 15 },
                }}
                sx={{
                  marginBottom: 2,
                  backgroundColor: "#ffffff",
                  borderColor: "#C1C6C9",
                }}
              />
              <TextField
                id="outlined-basic-2"
                label={`${Language(_mall, language, "lastname")}*`}
                variant="outlined"
                fullWidth
                name="lastname"
                value={formData.lastname}
                onChange={handleInputChange}
                InputLabelProps={{
                  style: { color: "#C1C6C9", fontSize: 15 },
                }}
                sx={{
                  marginBottom: 2,
                  backgroundColor: "#ffffff",
                  borderColor: "#C1C6C9",
                }}
              />
            </>
          )}

          {/* TELEFON ALANI */}
          <TextField
            id="outlined-basic-3"
            label={`${Language(_mall, language, "phone")}*`}
            variant="outlined"
            placeholder="5XXXXXXXXX"
            fullWidth
            name="phone"
            disabled={disabledPhone}
            value={formData.phone || ""}
            onChange={handleInputChange}
            InputLabelProps={{
              style: { color: "#C1C6C9", fontSize: 15 },
            }}
            sx={{
              marginBottom: showRoomNo ? 2 : 5,
              backgroundColor: "#ffffff",
              borderColor: "#C1C6C9",
            }}
          />

          {/* ÜCRETSİZ HİZMET (5.000 TL ve üzeri alışveriş) */}
          {freeServiceEnabled && (
            <FormGroup fullWidth>
              <FormControlLabel
                control={
                  <Checkbox
                    {...label}
                    checked={isFreeServiceEligible}
                    onChange={handleFreeServiceEligibleChange}
                    color="newRed"
                  />
                }
                label={
                  <Typography
                    variant="subtitle2"
                    sx={{
                      color: "#5E596D",
                      lineHeight: "16.94px",
                      fontSize: 13,
                      fontWeight: 600,
                    }}
                  >
                    {Language(
                      _mall,
                      language,
                      "minPurchaseCheckboxLabel",
                      minFreeServiceAmount.toLocaleString("tr-TR")
                    )}
                  </Typography>
                }
                sx={{ marginBottom: 2, alignItems: "center" }}
              />
            </FormGroup>
          )}

          {/* EMAIL ALANI */}
          {/* <TextField
            id="outlined-basic-email"
            label={`${Language(_mall, language, "email")}*`}
            variant="outlined"
            placeholder={"example@mail.com"}
            fullWidth
            name="email"
            disabled={disabledPhone && !!formData.email}
            value={formData.email || ""}
            onChange={handleInputChange}
            InputLabelProps={{
              style: { color: "#C1C6C9", fontSize: 15 },
            }}
            sx={{
              marginBottom: showRoomNo ? 2 : 5,
              backgroundColor: "#ffffff",
              borderColor: "#C1C6C9",
            }}
          /> */}

          {/* TESLİMAT TİPİ */}
          <FormControl fullWidth>
            <InputLabel
              style={{ color: "#C1C6C9", fontSize: 15 }}
              id="demo-simple-select-label"
            >
              {Language(_mall, language, "deliveryType")}*
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label={Language(_mall, language, "deliveryType")}
              name="deliveryType"
              value={formData.deliveryType}
              onChange={handleInputChange}
              sx={{
                marginBottom: 2,
                backgroundColor: "#ffffff",
                borderColor: "#C1C6C9",
              }}
            >
              {mall &&
                deliveryTypes.map((type) => (
                  <MenuItem key={type.type} value={type.type}>
                    {type.title}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>

          {formData.deliveryType === "points" && (
            <>
              <FormControl fullWidth>
                <InputLabel
                  style={{ color: "#C1C6C9", fontSize: 15 }}
                  id="demo-simple-select-label"
                >
                  {Language(_mall, language, "pointType")}*
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label={Language(_mall, language, "pointType")}
                  name="selectedPointType"
                  value={selectedPointType}
                  onChange={handlePointTypeChange}
                  sx={{
                    marginBottom: 2,
                    backgroundColor: "#ffffff",
                    borderColor: "#C1C6C9",
                  }}
                >
                  {mall &&
                    pointsTypes.map((type) => (
                      <MenuItem key={type} value={type}>
                        {type === "easypoint"
                          ? "Easy Point"
                          : Language(_mall, language, "location")}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>

              {/* İkinci Select Bileşeni */}
              {selectedPointType && (
                <FormControl fullWidth>
                  <InputLabel
                    style={{ color: "#C1C6C9", fontSize: 15 }}
                    id="second-select-label"
                  >
                    {selectedPointType === "easypoint"
                      ? "Easy Point"
                      : Language(_mall, language, "location")}
                    *
                  </InputLabel>
                  <Select
                    labelId="second-select-label"
                    id="second-select"
                    label={
                      selectedPointType === "easypoint"
                        ? "Easy Point"
                        : Language(_mall, language, "location")
                    }
                    value={
                      selectedSubValue ? JSON.stringify(selectedSubValue) : ""
                    }
                    onChange={(e) => {
                      const parsed = JSON.parse(e.target.value);
                      console.log("selectedSubValue:", parsed);
                      setSelectedSubValue(parsed);
                    }}
                    sx={{
                      marginBottom: 2,
                      backgroundColor: "#ffffff",
                      borderColor: "#C1C6C9",
                    }}
                  >
                    {JSON.parse(storedMall)[0]
                      .deliveryTypes.points.filter(
                        (point) =>
                          point.type === selectedPointType &&
                          point.isVisible !== false
                      )
                      .map((point) => (
                        <MenuItem
                          key={point.id}
                          value={JSON.stringify(point)}
                        >
                          {point.title}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              )}
            </>
          )}

          {formData.deliveryType === "address" && (
            <>
              <FormControl fullWidth>
                <InputLabel
                  style={{ color: "#C1C6C9", fontSize: 15 }}
                  id="demo-simple-select-label"
                >
                  {Language(_mall, language, "addressType")}*
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label={Language(_mall, language, "addressType")}
                  name="selectedAddressType"
                  value={selectedAddressType}
                  onChange={handlePredefinedTypeChange}
                  sx={{
                    marginBottom: 2,
                    backgroundColor: "#ffffff",
                    borderColor: "#C1C6C9",
                  }}
                >
                  {mall && predefinedTypes?.length > 0 && (
                    <MenuItem value={"predefined"}>
                      {Language(_mall, language, "enterPredefinedAddress")}
                    </MenuItem>
                  )}
                  {mall && (
                    <MenuItem value={"address"}>
                      {Language(_mall, language, "enterAddress")}
                    </MenuItem>
                  )}
                </Select>
              </FormControl>

              {selectedAddressType === "address" && (
                <>
                  <div
                    style={{
                      width: "100%",
                      flexDirection: "row",
                      display: "flex",
                      gap: "15px",
                    }}
                  >
                    <TextField
                      id="outlined-basic-4"
                      label={Language(_mall, language, "city")}
                      variant="outlined"
                      fullWidth
                      name="city"
                      value={JSON.parse(storedMall)[0].city}
                      disabled
                      InputLabelProps={{
                        style: { color: "#C1C6C9", fontSize: 15 },
                      }}
                      sx={{
                        marginBottom: 2,
                        backgroundColor: "#ffffff",
                        borderColor: "#C1C6C9",
                      }}
                    />

                    <FormControl fullWidth>
                      <InputLabel
                        style={{ color: "#C1C6C9", fontSize: 15 }}
                        id="demo-simple-select-label"
                      >
                        {Language(_mall, language, "district")}*
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label={Language(_mall, language, "district")}
                        name="selectedAddressType"
                        value={selectedTown}
                        disabled={
                          (isFreeServiceEligible
                            ? freeDeliveryTownList
                            : townList
                          )?.length === 1
                        }
                        onChange={handleChangeTown}
                        sx={{
                          marginBottom: 2,
                          backgroundColor: "#ffffff",
                          borderColor: "#C1C6C9",
                        }}
                      >
                        {mall &&
                          (isFreeServiceEligible
                            ? freeDeliveryTownList
                            : townList
                          ).map((town) => (
                            <MenuItem key={town} value={town}>
                              {town}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </div>

                  <FormControl fullWidth>
                    <InputLabel
                      style={{ color: "#C1C6C9", fontSize: 15 }}
                      id="demo-simple-select-label"
                    >
                      {Language(_mall, language, "town")}*
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label={Language(_mall, language, "town")}
                      name="selectedTown"
                      value={selectedDistrict}
                      disabled={!selectedTown || districtList?.length === 1}
                      onChange={(e) => setSelectedDistrict(e.target.value)}
                      sx={{
                        marginBottom: 2,
                        backgroundColor: "#ffffff",
                        borderColor: "#C1C6C9",
                      }}
                    >
                      {mall &&
                        districtList?.map((district) => (
                          <MenuItem key={district} value={district}>
                            {district}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </>
              )}
            </>
          )}

          {selectedAddressType === "predefined" && (
            <>
              <FormControl fullWidth>
                <InputLabel
                  style={{ color: "#C1C6C9", fontSize: 15 }}
                  id="demo-simple-select-label"
                >
                  {Language(_mall, language, "enterPredefinedAddress")}*
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label={Language(_mall, language, "enterPredefinedAddress")}
                  name="selectedPredefined"
                  value={selectedPredefined}
                  onChange={(e) => setSelectedPredefined(e.target.value)}
                  sx={{
                    marginBottom: 2,
                    backgroundColor: "#ffffff",
                    borderColor: "#C1C6C9",
                  }}
                >
                  {mall &&
                    mall[0].deliveryTypes.predefined.map((type) => (
                      <MenuItem key={type} value={type}>
                        {type.title}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>

              {selectedPredefined.type === "hotel" && (
                <TextField
                  id="outlined-basic-4"
                  label={`${Language(_mall, language, "roomNo")}*`}
                  variant="outlined"
                  fullWidth
                  name="hotelRoom"
                  value={hotelRoom}
                  onChange={(e) => setHotelRoom(e.target.value)}
                  InputLabelProps={{
                    style: { color: "#C1C6C9", fontSize: 15 },
                  }}
                  sx={{
                    marginBottom: 5,
                    backgroundColor: "#ffffff",
                    borderColor: "#C1C6C9",
                  }}
                />
              )}
            </>
          )}

          {formData.deliveryType === "postbox" && (
            <>
              <FormControl fullWidth>
                <InputLabel
                  style={{ color: "#C1C6C9", fontSize: 15 }}
                  id="demo-simple-select-label"
                >
                  {Language(_mall, language, "lockboxLocation")}*
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label={Language(_mall, language, "lockboxLocation")}
                  name="selectedLockBox"
                  value={selectedLockBox}
                  onChange={(e) => {
                    console.log("selectedLockBox:", e.target.value);
                    setSelectedLockBox(e.target.value);
                  }}
                  sx={{
                    marginBottom: 2,
                    backgroundColor: "#ffffff",
                    borderColor: "#C1C6C9",
                  }}
                >
                  {mall &&
                    lockBoxList.map((lockBox) => (
                      <MenuItem key={lockBox.id} value={lockBox}>
                        {lockBox.title}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </>
          )}

          {formData.deliveryType && (
            <>
              {selectedAddressType === "address" && (
                <TextField
                  id="outlined-multiline-1"
                  label={Language(_mall, language, "enterFullAddress")}
                  multiline
                  fullWidth
                  rows={4}
                  value={fullAddress}
                  onChange={(e) => setFullAddress(e.target.value)}
                  InputProps={{
                    style: {
                      height: 100,
                    },
                  }}
                  sx={{
                    marginBottom: 2,
                    backgroundColor: "#ffffff",
                    borderColor: "#C1C6C9",
                  }}
                />
              )}

              <TextField
                id="outlined-multiline-2"
                label={
                  selectedAddressType === "address"
                    ? Language(_mall, language, "enterAddressNote")
                    : Language(_mall, language, "enterNote")
                }
                multiline
                fullWidth
                value={addressDescription}
                onChange={(e) => setAddressDescription(e.target.value)}
                rows={4}
                InputProps={{
                  style: {
                    height: 100,
                  },
                }}
                sx={{
                  marginBottom: 2,
                  backgroundColor: "#ffffff",
                  borderColor: "#C1C6C9",
                }}
              />
            </>
          )}

          {showCode && (
            <TextField
              id="outlined-basic-3"
              label={`${Language(_mall, language, "code")}*`}
              variant="outlined"
              fullWidth
              name="userCode"
              value={userCode}
              onChange={(e) => setUserCode(e.target.value)}
              InputLabelProps={{
                style: { color: "#C1C6C9", fontSize: 15 },
              }}
              sx={{
                backgroundColor: "#ffffff",
                borderColor: "#C1C6C9",
                marginBottom: "20px",
              }}
            />
          )}

          {(loginType === "1" || loginType === "3") && (
            <FormGroup fullWidth>
              {_mall === "galataport" && (
                <FormControlLabel
                  control={
                    <Checkbox
                      {...label}
                      checked={formData.checkbox3}
                      onChange={handleInputChange}
                      name="checkbox3"
                      defaultChecked
                      color="newRed"
                    />
                  }
                  label={
                    <Typography
                      variant="subtitle1"
                      sx={{
                        color: "#5E596D",
                        lineHeight: "19.5px",
                        fontSize: 13,
                        fontWeight: 600,
                      }}
                    >
                      {Language(_mall, language, "taxFree")}
                    </Typography>
                  }
                  sx={{ marginBottom: 5 }}
                />
              )}
            </FormGroup>
          )}

          {JSON.parse(storedMall)[0].calculationUnit === "free" && (
            <p style={{ color: "#DF524C" }}>
              {Language(_mall, language, "serviceIsFree")}
            </p>
          )}

          {JSON.parse(storedMall)[0].calculationUnit === "per-package" &&
            !isFreeServiceEligible && (
            <>
              {selectedSubValue && (
                <p style={{ color: "#DF524C" }}>
                  {Language(
                    _mall,
                    language,
                    "priceWillBeCalculation",
                    selectedSubValue.price + " " + selectedSubValue.currency
                  )}
                </p>
              )}
              {selectedPredefined && (
                <p style={{ color: "#DF524C" }}>
                  {Language(
                    _mall,
                    language,
                    "priceWillBeCalculation",
                    selectedPredefined.price + " " + selectedPredefined.currency
                  )}
                </p>
              )}
              {selectedTown && (
                <p style={{ color: "#DF524C" }}>
                  {Language(
                    _mall,
                    language,
                    "priceWillBeCalculation",
                    JSON.parse(storedMall)[0].deliveryTypes.localDelivery[
                      selectedTown
                    ].price +
                      " " +
                      JSON.parse(storedMall)[0].deliveryTypes.localDelivery[
                        selectedTown
                      ].currency
                  )}
                </p>
              )}
              {selectedLockBox && (
                <p style={{ color: "#DF524C" }}>
                  {Language(
                    _mall,
                    language,
                    "priceWillBeCalculation",
                    selectedLockBox.price + " " + selectedLockBox.currency
                  )}
                </p>
              )}
            </>
          )}

          {JSON.parse(storedMall)[0].calculationUnit === "service" && (
            <>
              {selectedSubValue && (
                <p style={{ color: "#DF524C" }}>
                  {Language(
                    _mall,
                    language,
                    "priceWillBe",
                    selectedSubValue.price + " " + selectedSubValue.currency
                  )}
                </p>
              )}
              {selectedPredefined && (
                <p style={{ color: "#DF524C" }}>
                  {Language(
                    _mall,
                    language,
                    "priceWillBe",
                    selectedPredefined.price + " " + selectedPredefined.currency
                  )}
                </p>
              )}
              {selectedTown && (
                <p style={{ color: "#DF524C" }}>
                  {Language(
                    _mall,
                    language,
                    "priceWillBe",
                    JSON.parse(storedMall)[0].deliveryTypes.localDelivery[
                      selectedTown
                    ].price +
                      " " +
                      JSON.parse(storedMall)[0].deliveryTypes.localDelivery[
                        selectedTown
                      ].currency
                  )}
                </p>
              )}
              {selectedLockBox && (
                <p style={{ color: "#DF524C" }}>
                  {Language(
                    _mall,
                    language,
                    "priceWillBe",
                    selectedLockBox.price + " " + selectedLockBox.currency
                  )}
                </p>
              )}
            </>
          )}

          {selectedAddressType === "address" &&
            formData?.deliveryType === "address" &&
            !freeServiceEnabled && (
              <Typography
                component="ul"
                sx={{ paddingLeft: 2, marginBottom: "15px", color: "#5E596D" }}
              >
                <li>
                  {use17Cutoff
                    ? Language(_mall, language, "timeInformationBefore17")
                    : Language(_mall, language, "timeInformationBefore")}
                </li>
                <li>
                  {use17Cutoff
                    ? Language(_mall, language, "timeInformationAfter17")
                    : Language(_mall, language, "timeInformationAfter")}
                </li>
              </Typography>
            )}

          <Button
            variant="contained"
            color="newRed"
            fullWidth
            sx={{ paddingY: 1.2 }}
            onClick={handleContinue}
            disabled={
              (loginType !== "2" &&
                (loading ||
                  formData.name === "" ||
                  formData.lastname === "" ||
                  formData.firm === "")) ||
              isButtonDisabled()
            }
          >
            {loading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              Language(_mall, language, "continue")
            )}
          </Button>

          {showCode && (
            <Button
              variant="text"
              color="newRed"
              fullWidth
              sx={{ paddingY: 1.2, marginTop: "20px" }}
              onClick={() => sendSMS(formData.phone)}
            >
              {Language(_mall, language, "codeAgain")}
            </Button>
          )}
        </Box>
      </Box>

      <Dialog open={success} onClose={() => setSuccess(false)}>
        <DialogTitle color={"green"}>
          {Language(_mall, language, "success")}
        </DialogTitle>
        <DialogContent>
          <Typography>{Language(_mall, language, "successMessage")}</Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setSuccess(false);
              navigate(`/${uri}`);
            }}
            color="primary"
          >
            {Language(_mall, language, "okay")}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={failed} onClose={() => setFailed(false)}>
        <DialogTitle color={"red"}>
          {Language(_mall, language, "error")}
        </DialogTitle>
        <DialogContent>
          <Typography>{Language(_mall, language, "errorMessage")}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setFailed(false)} color="primary">
            {Language(_mall, language, "okay")}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Midtown + Salı Easy Point uyarı dialog'u */}
      <Dialog
        open={serviceDayDialogOpen}
        onClose={() => setServiceDayDialogOpen(false)}
      >
        <DialogTitle>Bilgi</DialogTitle>
        <DialogContent>
          <Typography>
            Seçili hizmet türü Salı günü kullanılmamaktadır.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setServiceDayDialogOpen(false)}
            color="primary"
          >
            Tamam
          </Button>
        </DialogActions>
      </Dialog>

      <Typography
        sx={{
          color: "black",
          fontSize: 8,
          bottom: 5,
          textAlign: "center",
        }}
      >
        {Language(_mall, language, "version")} 0.2.5
      </Typography>
    </Container>
  );
}
